module.exports = {
  /* Main app */
  appName : 'Listings Generator',
  title: 'Listings Generator',
  hostname: 'http://localhost:1337',
  exportURL: "http://ec2-52-14-88-110.us-east-2.compute.amazonaws.com/",

  dataSheetID: "1EaZmeBu3Zo3YDKSF_cj6QbEQRsY6SF9ujqmcxG24664",
  upcSpreadSheetID: '1WMs3Iww-JVVJaW2qeSCI-gkXwdzxMNxZufpo7SeUlm4',
  googleArchiveFolderID: '1kI8_DkRH_sFqWt3gJtdbWQGuOcNTXvIe',

  googleRefreshToken: '1//04i1HtRLWusr_CgYIARAAGAQSNgF-L9IrEWi1MfQRjtMQdhwVRnG8JvyF81n61wrh3JluEslbqjAnGM6_yfKnnwTecCNcZqolAg',
  googleClientID: '643101473910-1qm4ujd3dehk43lqkiss8ne67la3qhkh.apps.googleusercontent.com',
  googleClientSecret: 'r6THYaotcaQaXDj_WUuiGbD3',

  wipersDataSheetID: '1JJt201fswZzNASaLmn6SdiGx-gqtc3gHbV0JylEVNqU'
};
